import apiClient from '@u/apiClient'
import GetMessageTextListController from '@/wayfinder/actions/App/Http/Controllers/MessageText/GetMessageTextListController'
import GetMessageTextByIdController from '@/wayfinder/actions/App/Http/Controllers/MessageText/GetMessageTextByIdController'
import CreateMessageTextController from '@/wayfinder/actions/App/Http/Controllers/MessageText/CreateMessageTextController'
import UpdateMessageTextController from '@/wayfinder/actions/App/Http/Controllers/MessageText/UpdateMessageTextController'
import DeleteMessageTextController from '@/wayfinder/actions/App/Http/Controllers/MessageText/DeleteMessageTextController'
import ReorderMessageTextsController from '@/wayfinder/actions/App/Http/Controllers/MessageText/ReorderMessageTextsController'
import GetConvertedMessageTextController from '@/wayfinder/actions/App/Http/Controllers/MessageText/GetConvertedMessageTextController'
import GetNewModelController from '@/wayfinder/actions/App/Http/Controllers/NewModel/GetNewModelController'

export default {
  // region fetch
  fetchMessageTextList(_context) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetMessageTextListController.get())
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchMessageTextById(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetMessageTextByIdController.get({ message_text: payload.id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  fetchNewMessageText(_context) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetNewModelController.get({ query: { model: 'messageText' } }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },

  // endregion

  // region store
  storeMessageText(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(CreateMessageTextController.post(), payload, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region update
  updateMessageText(_context, payload) {
    return new Promise((resolve, reject) => {
      // Multipart (the message can carry local files), so POST with `_method`: PHP does not
      // parse a multipart body on a real PUT.
      apiClient
        .formRoute(
          UpdateMessageTextController.put({ message_text: payload.id }),
          payload,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region delete
  deleteMessageText(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteMessageTextController.delete.delete({
            message_text: payload.id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region undoDelete
  undoDeleteMessageText(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteMessageTextController.undo.get({ message_text: payload.id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  // region reorder
  reorderMessageTexts(_context, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(ReorderMessageTextsController.put(), {
          message_texts: payload.message_texts
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  // endregion

  fetchMessageTextConverted: (_context, payload) => {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          GetConvertedMessageTextController.post({
            message_text: payload.message_text_id
          }),
          payload
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
